import React, { useState, useEffect } from "react";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import AddRowMaterialModal from "../../../components/shared/modalContent/AddRowMaterialModal";
import { useGetRejectionLogSummaryQuery } from "../../../app/globalApi";
import TotalCase from "../../../images/totalCase.svg";
import KgEntered from "../../../images/material_kg.svg";
import GreenRejected from "../../../images/green_cases_rejected.svg";
import RejectedCases from "../../../images/rejected_case.svg";
import DateSelector from "../../../components/shared/fields/DateSelector";
import {
  useGetRejectedLogQuery,
  useUpdatePaidStatusMutation,
} from "../unloading/unloadingApi";
import {
  formatDateAndTimeFromUTC,
  formatTimeFromUTC,
} from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import { Dropdown } from "react-bootstrap";
import { OrangeArrow } from "../../../svgFiles/OrangeArrow";
import CommonDeleteModal from "../../../components/shared/modalLayout/CommonDeleteModal";
import {
  convertToUserTimezone,
  formatDateAndTime,
  getCurrentDate,
  showToast,
} from "../../../helpers/Utils";
import {
  PROJECT_DATE_FORMAT,
  PROJECT_DATETIME_FORMAT,
} from "../../../helpers/constants";
const RejectionLog = () => {
  const [page, setPage] = useState(1);
  const [addWashing, setAddWashing] = useState(false);
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("rejection");
  const AddWashing = () => {
    setAddWashing(true);
  };
  const [loadingStatusId, setLoadingStatusId] = useState(null);
  const [showStatusConfirmationModal, setShowStatusConfirmationModal] =
    useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState({
    id: null,
    bill_number: null,
    newStatus: null,
  });
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({
    supplier_name: "",
    batch_code: "",
    date: "",
    paid_status: "",
  });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };

  const {
    data: rawMaterial,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetRejectedLogQuery({ page, ...filter });

  const [updatePaidStatus, { isLoading: isUpdating }] =
    useUpdatePaidStatusMutation();
  const { _t } = useTranslator();

  const handlePageChange = (page) => {
    setPage(page);
  };

  const { data: summaryData } = useGetRejectionLogSummaryQuery({ tab, date });

  const confirmChangeStatusPrompt = (id, newStatus) => {
    setPendingStatusChange({ id, newStatus });
    setShowStatusConfirmationModal(true);
  };

  // console.log(rawMaterial.data)
  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  const listItems = [
    {
      label: _t("total_cases_entered", "Total Cases Entered"),
      value: summaryData?.data.total_cases_entered,
      icon: TotalCase,
    },
    {
      label: _t("material_entered_kg", "Material Entered in KG"),
      value: summaryData?.data.material_entered_kg,
      icon: KgEntered,
    },
    {
      label: _t("green_cases_rejected", "Green Cases Rejected"),
      value: summaryData?.data.green_cases_rejected,
      icon: GreenRejected,
    },
    {
      label: _t("material_rejected_kg", "Material Rejected in KG"),
      value: summaryData?.data.material_rejected_kg,
      icon: RejectedCases,
    },
  ];

  const handleChangeStatus = async (id, status) => {
    try {
      setLoadingStatusId(id);
      const result = await updatePaidStatus({
        id,
        requestBody: { status: status },
      }).unwrap();

      if (result && result.success) {
        refetch();
      } else {
        showToast(
          "Failed to update status: API returned unsuccessful response",
        );
      }
    } catch (error) {
    } finally {
      setLoadingStatusId(null);
      setShowStatusConfirmationModal(false);
      setPendingStatusChange({
        id: null,
        newStatus: null,
      });
    }
  };

  const columns = [
    {
      label: _t("unloading_date", "Unloading Date"),
      accessor: "unloading_date",
      cell: ({ value }) =>
        convertToUserTimezone(value, PROJECT_DATETIME_FORMAT),
    },
    {
      label: _t("supplier_name", "Supplier Name"),
      accessor: "supplier_name",
    },
    {
      label: _t("batch_code", "Batch Code"),
      accessor: "batch_code",
    },

    {
      label: _t("kg_entered", "KG Entered"),
      accessor: "kg_entered",
    },
    {
      label: _t("kg_rejected_expected", "KG Rejected (Expected)"),
      accessor: "rejected_case_count_kg",
    },
    {
      label: _t("kg_rejected_actual", "KG Rejected (Actual)"),
      accessor: "total_rejected_kg_actual",
    },
    {
      label: _t("cases_entered", "Cases Entered"),
      accessor: "total_cases",
    },
    {
      label: _t("cases_rejected", "Cases Rejected"),
      accessor: "rejected_case_count",
    },
    {
      label: _t("cases_paid", "Cases Paid"),
      cell: ({ row }) => row.total_cases - row.rejected_case_count,
    },
    {
      label: _t("kg_paid", "KG Paid"),
      accessor: "kg_after_wash",
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ row }) => {
        const currentStatus = row.paid_status || "unpaid";
        const isLoading = loadingStatusId === row.id;

        return (
          <>
            {currentStatus === "paid" ? (
              <span className="cursor-pointer cmn_badge text-center px-4">
                {isLoading
                  ? `${_t("updating", "Updating")}...`
                  : _t(currentStatus.toUpperCase() ,currentStatus.toUpperCase())}
              </span>
            ) : (
              <Dropdown className="select_status">
                <Dropdown.Toggle
                  variant="unset"
                  size="sm"
                  className="d-flex gap-2 align-items-center justify-content-center"
                  disabled={isLoading}
                >
                  {isLoading
                    ? `${_t("updating", "Updating")}...`
                    : _t(currentStatus.toUpperCase(),currentStatus.toUpperCase())}{" "}
                  {OrangeArrow}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      confirmChangeStatusPrompt(row.id, "paid");
                    }}
                    disabled={isLoading}
                  >
                    {_t("Paid", "Paid")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      confirmChangeStatusPrompt(row.id, "unpaid");
                    }}
                    disabled={isLoading}
                  >
                    {_t("Unpaid", "Unpaid")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <div>
        {addWashing && (
          <AddRowMaterialModal show={addWashing} setShow={setAddWashing} />
        )}
        <div className="overview cmn_card mb-3">
          <div className="overview_header d-flex gap-2 align-items-center">
            <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
            <DateSelector setDate={setDate} />
          </div>
          <ul className="m-0 grid_card_wrapper">
            {listItems.map((list, index) => (
              <GridCard
                key={index}
                title={list.label}
                value={list.value}
                icon={list.icon}
                day={
                  currentDate === date
                    ? _t("today", "Today")
                    : formatDateAndTime(date, PROJECT_DATE_FORMAT)
                }
              />
            ))}
          </ul>
        </div>

        <Datatable
          title={_t("rejection_title", "Rejection Log")}
          columns={columns}
          onClick={AddWashing}
          tableData={rawMaterial?.data}
          pagination
          page={page}
          onPageChange={handlePageChange}
          showFilter={handleFilterApply}
          showFilterButton={true}
          filterModule="rejection_log"
          filters={appliedFilters}
          isLoading={isLoading || isFetching}
        />
      </div>
      <CommonDeleteModal
        show={showStatusConfirmationModal}
        handleClose={() => {
          setShowStatusConfirmationModal(false);
        }}
        title={_t("confirm_update", "Confirm Update")}
        message={`${_t(
          "are_you_sure_you_want_to_update",
          "Are you sure you want to update",
        )} ?`}
        onConfirm={async () => {
          if (pendingStatusChange.id && pendingStatusChange.newStatus) {
            await handleChangeStatus(
              pendingStatusChange.id,
              pendingStatusChange.newStatus,
            );
          }
        }}
        buttonLabel={"Update"}
      />
    </>
  );
};

export default RejectionLog;
